import "../../shared/styles/index.css";
import admisionBanner from "../../assets/images/admissionBanner/admissionBanner.png";
import Why_Cdgi from "./Why_Cdgi";
import Placement_Highlight from "./Placement_Highlight";
import College_Help_Section from "./College_Help_Section";
import Institute_Highlights from "./Institute_Highlights";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import Course_Card from "./Course_Card";
import Marquee from "../home/Marquee";
import { useState } from "react";
import { CreateStudentEnquirey } from "../../api/Global";
import { Modal } from "react-bootstrap";

const Top_Engineering_Collge_In_Indore = () => {
  const navigate = useNavigate();
  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");
  const [mathAnswer, setMathAnswer] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");
  const [sumAnswerError, setsumAnswerError] = useState("");

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");
    setsumAnswerError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
    if (mathAnswer.toString() !== "14")
      return setsumAnswerError("Please add and put the correct value");
    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
        setMathAnswer("");
        setShow(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };


  return (
    <div
      className="page-template-default page page-id-2585 desktop desktop-menu mobile-menu-push-to-left header-sticky-both wide 
        page-has-no-sidebar title-bar-none woocommerce elementor-default elementor-kit-22 elementor-page elementor-page-2585 e--ua-blink
         e--ua-chrome e--ua-webkit loaded"
      data-elementor-device-mode="desktop"
    >
      <Helmet>
        <title>Top Engineering Colleges in Indore – CDGI B.Tech Programs</title>
        <meta
          name="description"
          content="Explore B.Tech programs at CDGI, one of the top engineering colleges in Indore. Specializations in CSE, IT, AI, ECE, Mechanical & Civil Engineering."
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Top Engineering Colleges in Indore – CDGI B.Tech Programs"
        />
        <meta
          property="og:description"
          content="Explore B.Tech programs at CDGI, one of the top engineering colleges in Indore. Specializations in CSE, IT, AI, ECE, Mechanical & Civil Engineering."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://cdgi.edu.in/Top_Engineering_College_In_Indore"
        />
        <link
          rel="canonical"
          href="https://cdgi.edu.in/Top_Engineering_College_In_Indore"
        />
      </Helmet>
 {/*  modal code [admission form] */}

      <Modal
        size="lg"
        className="asmission_enquiry"
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{
              textAlign: "center",
              width: "100%",
              color: "#007bff",
            }}
          >
            Admission Enquiry Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white p-2 p-lg-5">
            <div className="modlaPopup">
              <div className="elementor-widget-container">
                <form className="wpcf7-form">
                  <div className="form-group mb-3">
                    <label>Your Name</label>
                    <input
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      value={name}
                    />
                    {nameError && <p className="text-danger">{nameError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Your Email</label>
                    <input
                      className="form-control"
                      placeholder="Email ID"
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      value={email}
                    />
                    {emailError && <p className="text-danger">{emailError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Mobile Number</label>
                    <input
                      className="form-control"
                      placeholder="Phone"
                      onChange={(e) => setMobile(e.target.value)}
                      type="number"
                      name="mobile"
                      value={mobile}
                    />
                    {mobileError && (
                      <p className="text-danger">{mobileError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>City</label>
                    <input
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => setCity(e.target.value)}
                      type="text"
                      name="city"
                      value={city}
                    />
                    {cityError && <p className="text-danger">{cityError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Course</label>
                    <select
                      className="form-control"
                      required
                      name="course"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    >
                      <option value="">Please select Any Course</option>
                      <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                        Engineering Courses [CS, IT, AI & DS, CSIT]
                      </option>
                      <option value="B.Tech. Course [EC]">
                        Engineering Course [Electronics & Comm. Engg.]
                      </option>
                      <option value="B.Tech. Course [ME]">
                        Engineering Course [Mechanical Engineering]
                      </option>
                      <option value="B.Tech. Course [Civil Engg.]">
                        Engineering Course [Civil Engineering]
                      </option>
                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                        Pharmacy Courses [B.Pharm, D.Pharm]
                      </option>
                      <option value="Pharmacy Course[M.Pharm]">
                        Pharmacy Course [M.Pharm]
                      </option>
                      <option value="Management Courses[MBA(FT,MM,FA)]">
                        Management Courses [MBA(FT,MM,FA)]
                      </option>
                      <option value="Professional Course [BBA]">
                        Professional Courses [BBA]
                      </option>
                      <option value="Professional Course[BCA]">
                        Professional Courses [BCA]
                      </option>
                      <option value="Professional Course[B.Com]">
                        Professional Courses [B.Com]
                      </option>
                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                        Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                      </option>
                      <option value="MCA Course">MCA Course</option>
                    </select>
                    {courseError && (
                      <p className="text-danger">{courseError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>What is nine plus five?</label>
                    <input
                      className="form-control"
                      placeholder="Answer"
                      onChange={(e) => setMathAnswer(e.target.value)}
                      type="text"
                      name="mathAnswer"
                      value={mathAnswer}
                    />
                    {sumAnswerError && (
                      <p className="text-danger">{sumAnswerError}</p>
                    )}
                  </div>
                  {/* 
                  <div className="form-group">
                    <div className="form-submit">
                      <button  type="button" onClick={HandleSubmit} className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div> */}

                  <div className="form-group mb-3 text-center">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={HandleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Header />

      <div className="marquee-container">
        <Marquee onClick={openModal} />
      </div>

      <div className="main-container">
        <Link to="https://application.cdgi.edu.in/">
          <img src={admisionBanner} alt="Top Engineering Colleges in Indore" />
        </Link>
        <div className="second-container">
          <p>Top Engineering Colleges in Indore</p>
          <h1 className="heading">
            Top Engineering Colleges in Indore – Discover CDGI{" "}
          </h1>
          <p className="title">
            Chameli Devi Group of Institutions (CDGI) is proudly ranked among
            the top engineering colleges in Indore. With a commitment to
            academic excellence, future-driven programs, and state-of-the-art
            infrastructure, CDGI is a preferred destination for students seeking
            quality B.Tech education in Madhya Pradesh. Our NAAC A+
            accreditation, AICTE approval, and affiliation with RGPV Bhopal
            further position us as one of the most trusted engineering
            institutes in the region.
            <br />
            We offer a diverse range of B.Tech programs designed to meet
            industry needs and technological advancement, ensuring our students
            are career-ready upon graduation.
          </p>
         <button onClick={openModal}>
          Apply Now 
          </button>
        </div>

        <Course_Card id="course-card" />

        <Why_Cdgi />
        <Placement_Highlight />
        <College_Help_Section />
        <Institute_Highlights />
        <Footer />
      </div>
    </div>
  );
};

export default Top_Engineering_Collge_In_Indore;
